/* storybook-check-ignore */
import { Box } from '@opendoor/bricks-next';
import { Divider } from '@opendoor/bricks/core';
import dynamic from 'next/dynamic';

import { PropertyDetailsType } from '../types';

interface PropertyCTAsProps {
  property: PropertyDetailsType;
}

const BuyDirectCTA = dynamic(() => import('../BuyDirectCTA').then((mod) => mod.BuyDirectCTA), {
  ssr: false,
});

export const PropertyCTAs = ({ property }: PropertyCTAsProps) => {
  if (property.displayBadge !== 'ON_THE_MARKET') {
    return null;
  }

  return (
    <Box tag="menu" px={0} mt="$24x">
      <BuyDirectCTA property={property} />
      <Divider mt={48} />
    </Box>
  );
};
